import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { OrganizationServiceRow } from "../organizationServicesViewConfig";
import styles from "../OrganizationServices.module.scss";

export const OrganizationServiceNameCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, OrganizationServiceRow, string>) => (
        <span className={styles.name}>{row.original.name}</span>
    ),
);
